module.exports = __webpack_public_path__ + "static/img/tool_service_5.f8ff7d76.png";